import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  return (
    <section className="banner_moodbe">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            className="my-auto text-center"
          >
            <div className="banner_img_1">
              <StaticImage
                src="../../../images/case-studies/moodbe/banner_img_1.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={494}
                height={550}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/moodbe/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={261}
                height={192}
              />
            </div>
            <p>
              MoodBe is a revolutionary dating app that uses the user’s mood and
              interests to connect them with like-minded individuals. The app is
              designed to match them with people who share similar passions and
              emotional states, helping them find their perfect match. Whether
              they’re looking for someone to spend a night out with or are
              looking for potential marriage partners, MoodBe has a match for
              everyone.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/moodbe/id6444644149">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.mood_be">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={3}
            lg={3}
            xl={3}
            xxl={3}
            className="my-auto text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/moodbe/banner_img_2.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={414}
                height={575}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
